import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// Context Providers
import { AuthProvider } from './context/AuthContext';
import { ChatProvider } from './context/ChatContext';
import { ToastProvider } from './components/ui/Toast';

// Layout Components
import { Layout, ProtectedRoute } from './components/layout';
import ScrollToTop from './components/ScrollToTop';

// Pages
import HomePage from './pages/HomePage';
import PricingPage from './pages/PricingPage';
import SettingsPage from './pages/SettingsPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import SuccessPage from './pages/SuccessPage';
import NotFoundPage from './pages/NotFoundPage';

// Auth Pages
import SignInPage from './pages/auth/SignInPage';
import SignUpPage from './pages/auth/SignUpPage';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import ResetPasswordPage from './pages/auth/ResetPasswordPage';

// Legal Pages
import PrivacyPage from './pages/legal/PrivacyPage';
import TermsPage from './pages/legal/TermsPage';
import CookiesPage from './pages/legal/CookiesPage';

// Calculator Pages
import CalculatorPage from './pages/calculators/CalculatorPage';

// Content Pages
import HowItWorksPage from './pages/HowItWorksPage';
import FAQPage from './pages/FAQPage';
import BlogPage from './pages/blog/BlogPage';
import BlogPostPage from './pages/blog/BlogPostPage';

// Styles
import './App.css';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <AuthProvider>
          <ChatProvider>
            <ToastProvider>
              <Routes>
                <Route path="/" element={<Layout />}>
                  {/* Main Pages */}
                  <Route index element={<HomePage />} />
                  <Route path="pricing" element={<PricingPage />} />
                  <Route path="about" element={<AboutPage />} />
                  <Route path="contact" element={<ContactPage />} />
                  <Route path="success" element={<SuccessPage />} />

                  {/* Material Calculator Pages */}
                  <Route path="concrete-calculator" element={<CalculatorPage type="concrete" />} />
                  <Route path="drywall-calculator" element={<CalculatorPage type="drywall" />} />
                  <Route path="paint-calculator" element={<CalculatorPage type="paint" />} />
                  <Route path="flooring-calculator" element={<CalculatorPage type="flooring" />} />
                  <Route path="lumber-calculator" element={<CalculatorPage type="lumber" />} />
                  <Route path="roofing-calculator" element={<CalculatorPage type="roofing" />} />

                  {/* Content Pages */}
                  <Route path="how-it-works" element={<HowItWorksPage />} />
                  <Route path="faq" element={<FAQPage />} />
                  <Route path="blog" element={<BlogPage />} />
                  <Route path="blog/:slug" element={<BlogPostPage />} />

                  {/* Auth Pages */}
                  <Route path="signin" element={<SignInPage />} />
                  <Route path="signup" element={<SignUpPage />} />
                  <Route path="forgot-password" element={<ForgotPasswordPage />} />
                  <Route path="reset-password" element={<ResetPasswordPage />} />

                  {/* Protected Pages */}
                  <Route path="settings" element={
                    <ProtectedRoute>
                      <SettingsPage />
                    </ProtectedRoute>
                  } />

                  {/* Legal Pages */}
                  <Route path="privacy" element={<PrivacyPage />} />
                  <Route path="terms" element={<TermsPage />} />
                  <Route path="cookies" element={<CookiesPage />} />

                  {/* 404 */}
                  <Route path="*" element={<NotFoundPage />} />
                </Route>
              </Routes>
            </ToastProvider>
          </ChatProvider>
        </AuthProvider>
      </Router>
    </HelmetProvider>
  );
}

export default App;
